import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'
import { RADII } from 'styles/consts'

type TButtonVariant = 'primary' | 'secondary' | 'danger'

const variantStyles = {
  primary: css`
    color: ${COLORS.white};
    background-color: ${COLORS.primary};
    border: 1px solid ${COLORS.primary};

    &:hover:not(:disabled) {
      background-color: ${COLORS.primaryHover};
      border-color: ${COLORS.primaryHover};
    }
  `,
  secondary: css`
    color: ${COLORS.textSecondary};
    background-color: ${COLORS.surface};
    border: 1px solid ${COLORS.border};

    &:hover:not(:disabled) {
      background-color: ${COLORS.fill};
      border-color: ${COLORS.borderHover};
    }
  `,
  danger: css`
    color: ${COLORS.white};
    background-color: ${COLORS.danger};
    border: 1px solid ${COLORS.danger};

    &:hover:not(:disabled) {
      filter: brightness(0.92);
    }
  `
}

export const StyledButton = styled.button<{ $variant: TButtonVariant }>`
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  border-radius: ${RADII.field};
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
  white-space: nowrap;

  ${({ $variant }) => variantStyles[$variant]}

  &:focus-visible:not(:disabled) {
    outline: 2px solid ${COLORS.primary};
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }
`
